import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
const PrivateRoute = ({ children }) => {
 const [token, setToken] = useState(Cookies.get('AdminToken'));
 
   useEffect(() => {
     const checkToken = () => setToken(Cookies.get('AdminToken'));
     checkToken(); // immediate check
     const interval = setInterval(checkToken, 2000);
     return () => clearInterval(interval);
   }, []);
 
  if (!token) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute;
